import { Component, OnInit, Input, Output, EventEmitter, DoCheck, OnDestroy } from '@angular/core';
import { EditorConfiguration } from 'codemirror';
import { IRteListButtonItem, RteDialog, RTEAlertService } from 'rte-library';
import { QueryService } from 'src/app/reports/services/query.service';
import { QueryRequest } from 'src/app/reports/requests/query.request';
import { ExplainPlanDialogComponent } from 'src/app/reports/components/entity/explain-plan-dialog/explain-plan-dialog.component';
import { BaseComponent } from 'src/app/reports/shared/utils/base.component';

@Component({
  selector: 'app-query-detail',
  templateUrl: './query-detail.component.html',
  styleUrls: ['./query-detail.component.scss']
})
export class QueryDetailComponent extends BaseComponent implements OnInit, DoCheck, OnDestroy {

  //#region Inputs

  @Input() title: string;
  @Input() query: string;
  @Input() providerId: number;
  @Input() showActionButtons = true;

  @Input() disabled = false;
  @Input() value: number;

  //#endregion

  //#region Outputs

  @Output() queryChange = new EventEmitter<string>();

  //#endregion

  //#region Properties
  originalQueryGroup: string;
  originalQuery: string;
  editorOptions: EditorConfiguration = null;
  IsEnableButtonQueryOriginal = false;

  //#endregion

  //#region Ctor

  constructor(private queryService: QueryService,
    private alert: RTEAlertService,
    private dialog: RteDialog) {
      super();
    }

  //#endregion

  //#region Interface Implementations

  ngOnInit() {
    this.originalQuery = !!this.query ? this.query.toString() : '';
    this.IsEnableButtonQueryOriginal = false;

    this.editorOptions = this.getDefaulOptionCodeMirror();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngDoCheck() {
    this.editorOptions.readOnly = this.disabled;
  }

  //#endregion

  //#region Events

  onChange() {
    this.queryChange.emit(this.query);
    this.IsEnableButtonQueryOriginal = this.query !== this.originalQuery;
  }

  //#endregion

  //#region Configuratuion

  getDefaulOptionCodeMirror(): EditorConfiguration {
    return {
      lineNumbers: true,
      theme: 'eclipse',
      mode: 'text/x-pgsql',
      extraKeys: { 'Ctrl-Space': 'autocomplete' }
    };
  }

  showExplainPlan() {
    const obj: QueryRequest = {
      ProviderId: this.providerId,
      Query: this.query
    };
    this.subscription.add(this.queryService.explainPlan(obj).subscribe(result => {
      if (!result.Success) {
        this.alert.error(result.Message);
      } else {
        this.openExplainModal(result.ExplainPlan);
      }
    }));
  }

  //#endregion

  //#region Modal

  openExplainModal(value: string): void {
    this.dialog.customOpen(ExplainPlanDialogComponent, {
      minWidth: '95% !important',
      minHeight: '95% !important',
      data: value
    });
  }

  showQueryOriginal() {
    this.query = this.originalQuery.toString();
    this.IsEnableButtonQueryOriginal = false;
  }
  //#endregion
}
